
const state = {
    loginModelOpen:false,//登录模态框是否打卡
    registModelOpen:false,// 注册模态框是否打开
    findPasswordModelOpen:false,// 找回密码模态框是否打开
    menuOpen:false,// 右侧菜单栏是否打开
}
const getters = {

}
const mutations = {
    // 登录模态框
    loginModelOpenCtr: (state, payload) => {
        state.loginModelOpen = payload
        // 当登录框打开的时候，关闭注册框
        if(payload && state.registModelOpen){
            state.registModelOpen = false
        }
    },
    // 注册模态框
    registModelOpenCtr: (state, payload) => {
        state.registModelOpen = payload
        // 当注册框打开的时候，关闭登录框
        if(payload && state.loginModelOpen){
            state.loginModelOpen = false
        }
    },
    // 找回密码模态框
    findPasswordModelOpenCtr: (state, payload) => {
        state.findPasswordModelOpen = payload
        // 找回密码框打开的时候,注册框和登录框关闭
        if(payload){
            state.loginModelOpen = false
            state.registModelOpen = false
        }
    },
    // h5左侧菜单栏
    h5LeftMenuOpenCtr: (state, payload) => {
        console.log("payload",payload)
        state.menuOpen = payload
    },
}
const actions = {


}
const modules = {}
export default {
    namespaced: true,
    state() {
        return state
    },
    getters,
    mutations,
    actions,
    modules
}

